<h1>{{ 'tittle_name' | translate }}</h1>